/**
 * Connection point to `apps/cloud-api` — the *only* backend this app ever
 * talks to (no local sidecar, no pairing, unlike `apps/desktop`/`apps/
 * web-client`). Read from Vite's own env mechanism (`VITE_CLOUD_API_URL`,
 * `.env.example`), unlike `apps/desktop`'s hardcoded equivalent — this app
 * has a real path to a real deployed origin (`admin.stagvista.com` ->
 * `api.stagvista.com`, `docs/deployment.md` §1/§4.1) that a Tauri app's
 * lack of build-time env config doesn't.
 */
export const CLOUD_API_BASE_URL: string =
  (import.meta.env.VITE_CLOUD_API_URL as string | undefined) ?? "http://localhost:3000";
